import React, { useState, useEffect } from "react";
import {
  TextField,
  Button,
  Typography,
  Paper,
  Container,
  Card,
  CardContent,
  CardMedia,
  IconButton,
  Grid,
  Dialog,
  DialogContent,
  DialogActions
} from "@material-ui/core";
import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
import { connect } from "react-redux";
import axios from "axios";
import { setLoading, setSnackInfo } from "../redux/actions/appAction";
import HttpService from "../services/httpService";

function PartnersImg(props) {
  const [quotations, setQuotations] = useState([]);
  const [form, setForm] = useState({ name: "", imageUrl: "" });
  const [editId, setEditId] = useState(null);
  const [imageUrl,setImageUrl] = useState("")  
  const [deleteId, setDeleteId] = useState("")
  const [deleteModelIsOpen, setDeleteModelIsOpen] = useState(false);
  const fetchData = async () => {
    try {
      props.setLoading(true);
      const fetchData =
        await HttpService.getPartnersImg();
        setQuotations(fetchData?.data);
    } catch (error) {
      props.setSnackInfo({ message: "Error fetching data", severity: "error" });
    } finally {
      props.setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      props.setLoading(true);
  
      let response;
      if (editId) {
        response = await HttpService.editPartnersImg(editId, form);
      } else {
        response = await HttpService.createPartnersImg(form);
      }
  
      setForm({ name: ""});
      setImageUrl("")
      setEditId(null);
      fetchData();
    } catch (error) {
      props.setSnackInfo({ message: "Error submitting form", severity: "error" });
    } finally {
      props.setLoading(false);
    }
  };
  

  const handleEdit = (item) => {
    setForm({ name: item.name, imageUrl: item.imageUrl });
    setImageUrl(item.imageUrl)
    setEditId(item._id);
  };


  const handleDelete = async (id) => {
    try {
      props.setLoading(true);
      const response = await HttpService.deletePartnersImg(id);  // delete the image
      fetchData();                              // refresh the data
    } catch (error) {
      props.setSnackInfo({ message: "Error deleting item", severity: "error" });
    } finally {
      props.setLoading(false);
    }
  };

  const handleSImageUrl = async (event) => {
    props.setLoading(true);
    try {
      const fd = new FormData();
      fd.append("file", event.target.files[0]);
      const fileUploadRes = await HttpService.uploadFile(fd);
      setImageUrl(fileUploadRes.data); // Make sure it's a URL or expected format
      setForm({ ...form, imageUrl: fileUploadRes.data})
    } catch (error) {
      props.setSnackInfo("Something went wrong", "error");
    }
    props.setLoading(false);
  };
  return (
    <Container>
      <Typography variant="h4" style={{ marginTop: "30px", marginBottom: "20px" }}>
        Partner Images
      </Typography>

      {/* Add / Edit Form */}
      <Paper style={{ padding: "20px", marginBottom: "30px" }}>
        <form onSubmit={handleSubmit}>
          <TextField
            label="Name"
            value={form.name}
            onChange={(e) => setForm({ ...form, name: e.target.value })}
            fullWidth
            margin="normal"
          />
          {/* <TextField
            label="Image URL"
            value={form.imageUrl}
            onChange={(e) => setForm({ ...form, imageUrl: e.target.value })}
            fullWidth
            margin="normal"
          /> */}
            <Button
            variant="contained"
            component="label"
            fullWidth
            style={{
                backgroundColor: "#355025",
                color: "#FFF2EB",
                marginTop: "10px",
            }}
            >
            Upload Sub Images
            <input
                type="file"
                multiple
                hidden
                accept=".png, .jpg, .jpeg, .webp"
                onChange={(e)=>{
                    handleSImageUrl(e)
                }}

            />
            <input type="checkbox" checked={imageUrl!==""}></input>
            </Button>
            <Button
            type="submit"
            variant="contained"
            color="primary"
            style={{ marginTop: "10px" }}
            disabled={!form.name.trim() || imageUrl==""}
            >
            {editId ? "Update" : "Add"}
            </Button>
    </form>
      </Paper>

      {/* Cards Grid */}
      <Grid container spacing={3}>
        {quotations?.length > 0 &&
          quotations.map((item) => (
            <Grid item xs={12} sm={6} md={4} lg={3} key={item._id}>
              <Card style={{ position: "relative", height: "100%" }}>
                <div
                  style={{
                    height: "180px",             // fixed height
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    backgroundColor: "#f9f9f9",  // optional background
                    padding: "8px",
                  }}
                >
                  <img
                    src={item.imageUrl}
                    alt={item.name}
                    style={{
                      maxWidth: "100%",
                      maxHeight: "100%",
                      objectFit: "contain",     // key to show full image
                    }}
                  />
                </div>

                <CardContent>
                  <Typography variant="h6" component="div" noWrap>
                    {item.name}
                  </Typography>
                </CardContent>

                <div
                  style={{
                    position: "absolute",
                    top: 10,
                    right: 10,
                    display: "flex",
                    gap: "8px",
                  }}
                >
                  <IconButton onClick={() => handleEdit(item)} color="primary">
                    <EditIcon />
                  </IconButton>
                  <IconButton
                    onClick={() => {
                      setDeleteId(item?._id);
                      setDeleteModelIsOpen(true);
                    }}
                    color="secondary"
                  >
                    <DeleteIcon />
                  </IconButton>
                </div>
              </Card>
            </Grid>
          ))}
        </Grid>
       {/* Delete MOdel */}

          <Dialog
        open={deleteModelIsOpen}
        onClose={() => {
          setDeleteModelIsOpen(false);
        }}
        maxWidth="lg" // Adjust maxWidth ('xs', 'sm', 'md', 'lg', 'xl' for default sizes)
        PaperProps={{
          style: {
            width: "25%", // Set custom width
            maxHeight: "50vh", // Optionally limit height
          },
        }}
      >
        <DialogContent>
          <Typography variant="h6">
            {" "}
            Are you sure you want to delete it?
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button
            style={
              {
                //   backgroundColor: "red",
              }
            }
            variant="contained"
            color="primary"
            onClick={() => {
              handleDelete(deleteId)
              setDeleteModelIsOpen(false)
            }}
          >
            Yes
          </Button>
          <Button
            onClick={() => {
              setDeleteModelIsOpen(false);
            }}
            variant="contained"
            color="secondary"
          >
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
    </Container>
  );
}

export default connect(null, { setLoading, setSnackInfo })(PartnersImg);